import React, { useEffect } from 'react'
import styled from 'styled-components'
import CompFlatFields from '../../comps/FlatFields'
import { useSRRInDRS } from '../../useSRRInDRS'
import CompPreviewSection from '../../comps/Section'
import SRRMaterialAsphaltOtherFields from '@src/modules/SiteResoureRequirements/parts/4-Material/parts/AsOther/fields'

interface Props {

}

const CompPreviewMaterialAsphaltOther = (props: Props) => {
  const {

  } = props
  const [ srr ] = useSRRInDRS()
  if (srr === null) {
    return null
  }
  if (srr.material.asphalt.otherProducts === null) {
    return null
  }
  return <Wrapper>
    <CompPreviewSection 
      name={`Other Material (Asphalt)`}
    >
      <CompFlatFields
        value={srr.material.asphalt.otherProducts}
        fields={SRRMaterialAsphaltOtherFields}
      />
    </CompPreviewSection>
  </Wrapper>
}

const Wrapper = styled.div`

`

export default CompPreviewMaterialAsphaltOther